import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import "./bootstrap.min.css"
import "./layout.css"

import Navigation from "./global/navigation"
import Footer from "./global/footer"

const Layout = ({ children }) => {
  const layoutData = useStaticQuery(graphql`
    {
      navigation: site {
        siteMetadata {
          menuLinks {
            name
            link
            id
          }
        }
      }
      contact: wordpressPage(slug: { eq: "contact" }) {
        acf {
          phone
          instagram
          facebook
          location {
            text
            link_to_google_maps
          }
        }
      }
    }
  `)
  return (
    <React.Fragment>
      <Navigation
        navigationData={layoutData.navigation.siteMetadata.menuLinks}
      />

      {children}
      <div className="my-5" />
      <Footer
        footerData={layoutData.contact.acf}
        navigation={layoutData.navigation.siteMetadata.menuLinks}
      />
      <div style={{ padding: "1rem" }} />
    </React.Fragment>
  )
}

export default Layout
